import React, { useState } from 'react';
import './../styles/Buttons.css';

const useConfirmation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [options, setOptions] = useState([]);
  const [onCancel, setOnCancel] = useState(() => () => {});

  const showConfirmation = (msg, opts, onCancelAction) => {
    setMessage(msg);
    setOptions(opts);
    setOnCancel(() => onCancelAction);
    setIsVisible(true);
  };

  const hideConfirmation = () => {
    setIsVisible(false);
    setMessage('');
    setOptions([]);
  };

  const ConfirmationBox = () =>
    isVisible && (
      <div className="custom-modal-overlay">
        <div className="custom-modal">
          <p>{message}</p>
          <div className="modal-actions">
            {options.map((option, index) => (
              <button
                key={index}
                className={
                  option.className ||
                  `btn ${option.label === 'Mark as Important' ? 'btn-danger confirm-button' : 'btn-success confirm-button'}`
                }
                onClick={() => {
                  option.action();
                  hideConfirmation();
                }}
              >
                {option.label}
              </button>
            ))}
            <button
              className="btn btn-secondary"
              onClick={() => {
                onCancel();
                hideConfirmation();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );

  return { showConfirmation, ConfirmationBox };
};

export default useConfirmation;
